import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

export const api = {
  getSiteOverview: async () => (await client.get("/site")).data,
  createEstimate: async (payload) => (await client.post("/estimator", payload)).data,
  createLead: async (payload) => (await client.post("/leads", payload)).data,
  createBooking: async (payload) => (await client.post("/bookings", payload)).data,
  updateBookingRules: async (payload) =>
    (await client.put("/admin/settings/booking-rules", payload)).data,
  uploadImageFile: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    return (
      await client.post("/uploads/images", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
    ).data;
  },
  rotateImageFile: async (id, direction) =>
    (await client.post(`/uploads/images/${id}/rotate`, { direction })).data,
  getDashboard: async () => (await client.get("/admin/dashboard")).data,
  getLeads: async () => (await client.get("/admin/leads")).data,
  updateLeadStatus: async (id, payload) =>
    (await client.patch(`/admin/leads/${id}`, payload)).data,
  createGalleryItem: async (payload) =>
    (await client.post("/admin/gallery", payload)).data,
  deleteGalleryItem: async (id) => (await client.delete(`/admin/gallery/${id}`)).data,
  createTestimonial: async (payload) =>
    (await client.post("/admin/testimonials", payload)).data,
  deleteTestimonial: async (id) =>
    (await client.delete(`/admin/testimonials/${id}`)).data,
  createBlogPost: async (payload) =>
    (await client.post("/admin/blog-posts", payload)).data,
  deleteBlogPost: async (id) => (await client.delete(`/admin/blog-posts/${id}`)).data,
  getBookings: async () => (await client.get("/bookings")).data,
};
